import firebaseApp from "./config";

function sendError(msg) {
  return {
    message: msg || 'Check your internet connection.',
    status: 'error',
    data: null,
  };
}

export const login = async (phone, pass) => {
  try {
    const {userRecord} = await getUserByPhone(phone);
    if (userRecord && userRecord.status !== 'error') {
      const {email} = userRecord;
      return await firebaseApp.auth()
        .signInWithEmailAndPassword(email, pass)
        .then((res) => {
          return {
            message: 'Login successfully',
            status: 'ok',
            data: res,
          };
        })
        .catch((error) => {
          switch (error.code) {
            case 'auth/wrong-password':
              return sendError('Wrong password provided.');
            case 'auth/user-not-found':
              return sendError('User not found.');
            case 'auth/invalid-email':
              return sendError('Invalid credential provided.');
            case 'auth/too-many-requests':
              return sendError('Too many attempt, Please try after sometime.');
            default:
              return sendError('Invalid Credential Provided.');
          }
        });
    } else {
      return sendError('Phone number not registered.');
    }
  } catch (error) {
    return sendError('Check your internet connection.');
  }
};

const getUserByPhone = async (phoneNumber) => {
  try {
    let response = await fetch(
      'https://us-central1-araapp-90f11.cloudfunctions.net/app/phoneOne/',
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          phone: phoneNumber,
        }),
      },
    );
    let json = await response.json();
    return json;
  } catch (error) {
    return {
      data: null,
      message: error,
      status: 'error',
    };
  }
};